export default __webpack_public_path__ + "static/media/visa.cec2f586.svg";